import { Pipe, PipeTransform } from '@angular/core';
import {TranslateService} from "@ngx-translate/core";

@Pipe({name: 'translated'})
export class TranslatedPipe implements PipeTransform {

  private currentLanguage;
  constructor(
    private translate: TranslateService,
  ) {
    this.currentLanguage = this.translate.currentLang;
    this.translate.onLangChange.subscribe((language)=>{
    });
  }

  transform(value, args:string[]) : any {
    let translated = '';
    if(!value || typeof value !== 'object') return;
    if (value[this.currentLanguage]){
      translated = value[this.currentLanguage];
    } else {
      for(let lang of this.translate.langs){
        if (value[lang]){
          // translated = lang + ': ' + value[lang];
          translated = value[lang];
          return translated;
        }
      }
      // translated = 'Sorry, nothing to translate';
    }
    return translated;
  }
}



// WEBPACK FOOTER //
// C:/Development/Private Projects/random-ride/RandomRide/src/app/pipes/translated.pipe.ts